import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Icon } from "antd";
import NavBar from "../nav/NavBar/NavBar";
import Sidebar from "../../app/common/util/Sidebar";
import { REPORTS } from "./reportsConfig";

class ReportsPage extends Component {
  render() {
    return (
      <div className="reports-shell">
        <Sidebar />
        <NavBar />
        <main className="reports-page">
          <header className="reports-page__hero">
            <div className="reports-page__hero-text">
              <p className="reports-page__eyebrow">Analytics</p>
              <h1 className="reports-page__title">Reports</h1>
              <p className="reports-page__subtitle">
                Insights and operational metrics across orders, branches, and
                product lines.
              </p>
            </div>
          </header>

          <section className="reports-grid">
            {REPORTS.filter((r) => r.available).map((report) => (
              <Link
                key={report.id}
                to={report.path}
                className="reports-card"
                style={{ "--report-accent": report.accent }}
              >
                <div className="reports-card__icon-wrap">
                  <Icon type={report.icon} />
                </div>
                <div className="reports-card__body">
                  <h2 className="reports-card__title">{report.title}</h2>
                  <p className="reports-card__desc">{report.description}</p>
                </div>
                <span className="reports-card__cta">
                  Open report <Icon type="arrow-right" />
                </span>
              </Link>
            ))}
          </section>
        </main>
      </div>
    );
  }
}

export default ReportsPage;
